module.exports = __webpack_public_path__ + "img/stock6.30b0abdc.png";